import React from 'react';
import { Step } from 'react-joyride';

import SZJoyride from 'buyside/components/presentation/Joyride/szJoyride';
import { rankingIndexJoyrideSteps } from 'buyside/components/presentation/Joyride/RankingIndexJoyride/rankingIndexJoyrideHelper';

import { useIsMobile } from 'buyside/util/hooks/useIsMobile';
import { optOutJoyride, shouldHideJoyride } from 'buyside/util/joyrideUtil';

const joyrideCookieName = 'hideRankingIndexJoyride';

const RankingIndexJoyride: React.FC<{ isPublic: boolean }> = ({ isPublic }) => {
  const isMobile = useIsMobile();

  if (shouldHideJoyride(joyrideCookieName)) return null;

  const steps: Step[] = [
    ...(!isPublic ? [rankingIndexJoyrideSteps.followMember] : []),
    rankingIndexJoyrideSteps.topMostRecentIdeas,
    ...(!isMobile ? [rankingIndexJoyrideSteps.rankingsByCategory] : [])
  ];

  return (
    <SZJoyride
      callback={({ status }): void => optOutJoyride(status, joyrideCookieName)}
      continuous
      spotlightClicks
      steps={steps}
    />
  );
};

export default RankingIndexJoyride;
